export default "__VITE_ASSET__CcGD3VCF__"